import { render, staticRenderFns } from "./detailsMessageReceiveByLocal.vue?vue&type=template&id=08b7e328&"
import script from "./detailsMessageReceiveByLocal.vue?vue&type=script&lang=js&"
export * from "./detailsMessageReceiveByLocal.vue?vue&type=script&lang=js&"
import style0 from "./detailsMessageReceiveByLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports